import React from 'react';
import { Modal, Button, Text, Crate } from '@perch-labs/shrike';
import styled from 'styled-components';
import { ScrollablePdf } from 'pages/settings/secondary/contracts/personalized-contract/scrollable-pdf.component';

const ButtonContainer = styled(Crate)`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding: 16px 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.background.tertiary};
`;

export interface ContractPreviewDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  pdfUrl: string;
  contractDisplayName: string;
  isSubmitting: boolean;
  preText?: string;
  postText?: string;
}

const formatContractName = (name: string): string => {
  const lowercased = name.toLowerCase();
  return lowercased.replace(
    /\(([a-z])/g,
    (_match, firstLetter) => `(${firstLetter.toUpperCase()}`
  );
};

export const ContractPreviewDialog = ({
  isOpen,
  onClose,
  onAccept,
  pdfUrl,
  contractDisplayName,
  isSubmitting,
  preText,
  postText,
}: ContractPreviewDialogProps): JSX.Element | null => {
  if (!isOpen) return null;

  return (
    <Modal aria-label="Contract Preview" size="large">
      <Modal.Header title="" onClose={onClose} />
      <Modal.Content>
        <ScrollablePdf pdfUrl={pdfUrl} />
        {preText && postText && (
          <Text margin={{ bottom: '16px' }} textStyle="paragraph400">
            {preText} {formatContractName(contractDisplayName)}
            {postText} {formatContractName(contractDisplayName)}.
          </Text>
        )}
        <ButtonContainer>
          <Button onClick={onClose} backgroundless disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            onClick={onAccept}
            loading={isSubmitting}
            disabled={isSubmitting}
          >
            Sign and submit
          </Button>
        </ButtonContainer>
      </Modal.Content>
    </Modal>
  );
};
